module.exports = __webpack_public_path__ + "static/media/searchicn.ad690103.svg";